import { Component } from '@angular/core';
import { ActionButtonComponent } from '@vpfa/ui-kit';

@Component({
  selector: 'vpfa-mobile-action-button',
  templateUrl: './mobile-action-button.component.html',
  styleUrls: ['./mobile-action-button.component.scss'],
})
export class MobileActionButtonComponent extends ActionButtonComponent {}
